import { render, staticRenderFns } from "./XFooter.vue?vue&type=template&id=9871c6a8&scoped=true"
import script from "./XFooter.vue?vue&type=script&lang=js"
export * from "./XFooter.vue?vue&type=script&lang=js"
import style0 from "./XFooter.vue?vue&type=style&index=0&id=9871c6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9871c6a8",
  null
  
)

export default component.exports